import React, { useCallback } from 'react';
import numeral from 'numeral';
import { Dropdown } from 'react-bootstrap';

import CogIcon from 'ui-kit/icons/cog-icon/cog-icon';
import DataGrid, { SORT_DIRECTION } from 'ui-kit/data-grid/data-grid';

import './style.css';

const BidList = ({ bids, onApproveBid, onRejectBid, onReviewBid, onViewBid }) => {
    const getColumns = useCallback(() => {
        return [
            {
                label: 'Address',
                field: 'address',
                exportable: true,
                sort: true
            },
            {
                label: 'Parcel Number',
                field: 'parcelNumber',
                key: true,
                exportable: true,
                sort: true
            },
            {
                label: 'Status',
                field: 'status',
                exportable: true
            },
            {
                label: 'Date Submitted',
                field: 'dateSubmitted',
                exportable: true,
                sort: true
            },
            {
                label: 'Date Approved',
                field: 'dateApproved',
                exportable: true,
                sort: true
            },
            {
                label: 'Amount',
                field: 'amount',
                exportable: true,
                cellRenderer: (amount) => {
                    return numeral(amount).format('$0,0');
                },
                sort: (a, b, sortDirection) => {
                    const numberA = Number(a.replace('$', ''));
                    const numberB = Number(b.replace('$', ''));

                    if (sortDirection === SORT_DIRECTION.ASC) {
                        if (numberA < numberB) return -1;
                        return numberA > numberB ? 1 : 0;
                    }

                    if (numberA < numberB) return 1;
                    return numberA > numberB ? -1 : 0;
                }
            },
            {
                label: 'Actions',
                field: 'actions',
                cellRenderer: (bid) => {
                    const { id } = bid;
                    return (
                        <Dropdown>
                            <Dropdown.Toggle>
                                <CogIcon style={{ height: '1.5rem', width: '1.5rem' }} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => onViewBid({ id })}>View</Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item onClick={() => onApproveBid({ bid })}>Approve</Dropdown.Item>
                                <Dropdown.Item onClick={() => onReviewBid({ bid })}>Review</Dropdown.Item>
                                <Dropdown.Item onClick={() => onRejectBid({ bid })}>Reject</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    );
                }
            }
        ];
    }, [bids]);
    const columns = getColumns();

    return (
        <DataGrid
            id="bid-list"
            columns={columns}
            filters={[columns[0], columns[1]]}
            defaultSortCol={columns[3]}
            data={bids}
        />
    );
};

export default BidList;
